'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactBootstrap = require('react-bootstrap');

var _InputBlock = require('../DocEditor/InputBlock');

var _InputBlock2 = _interopRequireDefault(_InputBlock);

var _AuthEditor = require('./AuthEditor');

var _AuthEditor2 = _interopRequireDefault(_AuthEditor);

var _style = require('./style');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EditorButtons(_ref) {
  var saveEditing = _ref.saveEditing,
      cancelEditing = _ref.cancelEditing;

  return _react2.default.createElement(
    _reactBootstrap.Grid,
    null,
    _react2.default.createElement(
      _reactBootstrap.Row,
      { className: _style2.default.btnLine },
      _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 2, sm: 2 },
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn-primary form-control',
            onClick: saveEditing
          },
          '\u5132\u5B58'
        )
      ),
      _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 2, sm: 2 },
        _react2.default.createElement(
          'button',
          {
            className: _style2.default.btnLink + ' ' + _style2.default.btnCancel,
            onClick: cancelEditing
          },
          '\u53D6\u6D88'
        )
      )
    )
  );
}
EditorButtons.propTypes = {
  saveEditing: _propTypes.func.isRequired,
  cancelEditing: _propTypes.func.isRequired
};

var DocEditor = function DocEditor(props) {
  var spliter = props.spliter;

  var getChildProps = spliter(props);

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h3',
      { className: _style2.default.pageTitle },
      '\u4F7F\u7528\u8005\u7FA4\u7D44\u8A2D\u5B9A'
    ),
    _react2.default.createElement(
      'div',
      { className: _style2.default['group-editor'] },
      _react2.default.createElement(EditorButtons, props),
      _react2.default.createElement(
        _reactBootstrap.Grid,
        null,
        _react2.default.createElement(
          _reactBootstrap.Row,
          null,
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 12 },
            _react2.default.createElement(_InputBlock2.default, getChildProps('account'))
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Row,
          null,
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 12 },
            _react2.default.createElement(_AuthEditor2.default, getChildProps('authority'))
          )
        )
      ),
      _react2.default.createElement(EditorButtons, props)
    )
  );
};
DocEditor.propTypes = {
  spliter: _propTypes.func.isRequired
};

exports.default = DocEditor;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/GroupEditor/GroupEditor.js
// module id = 1733
// module chunks = 0